export const changeTheme = () => {
  return {
    type: 'CHANGE_THEME',
  };
};
